import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { ClockIcon } from 'lucide-react';
interface CountdownTimerProps {
  targetDate?: Date;
  compact?: boolean;
}
export function CountdownTimer({
  targetDate,
  compact = false
}: CountdownTimerProps) {
  // Calculate end time: 24 hours from now
  const getEndTime = () => {
    const now = new Date();
    return new Date(now.getTime() + 24 * 60 * 60 * 1000); // 24 hours from now
  };
  const [endTime] = useState(getEndTime());
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = endTime.getTime() - now;
      if (distance < 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <VStack spacing={compact ? 0 : 1} data-id="element-204">
      <Box bg="linear-gradient(135deg, #DC2626 0%, #991B1B 100%)" color="white" px={compact ? 3 : 4} py={compact ? 2 : 3} borderRadius="lg" minW={compact ? '50px' : '70px'} textAlign="center" fontWeight="black" fontSize={compact ? '2xl' : '3xl'} borderWidth="2px" borderColor="red.400" position="relative" className="timer-glow" _before={{
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: 'lg',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%)',
      pointerEvents: 'none'
    }} data-id="element-205">
        <Text as="span" display="inline-block" data-id="element-206">
          {String(value).padStart(2, '0')}
        </Text>
      </Box>
      {!compact && <Text fontSize="xs" color="white" fontWeight="bold" textTransform="uppercase" letterSpacing="wider" data-id="element-207">
          {label}
        </Text>}
    </VStack>;
  return <Flex gap={compact ? 2 : 3} justify="center" align="center" flexWrap="wrap" data-id="element-208">
      <Box className="timer-pulse" data-id="element-209">
        <ClockIcon color="white" size={compact ? 24 : 32} strokeWidth={2.5} data-id="element-210" />
      </Box>
      <TimeUnit value={timeLeft.hours} label="horas" data-id="element-211" />
      <Text fontSize={compact ? '2xl' : '3xl'} fontWeight="black" color="yellow.300" textShadow="0 0 10px rgba(252, 211, 77, 0.5)" data-id="element-212">
        :
      </Text>
      <TimeUnit value={timeLeft.minutes} label="minutos" data-id="element-213" />
      <Text fontSize={compact ? '2xl' : '3xl'} fontWeight="black" color="yellow.300" textShadow="0 0 10px rgba(252, 211, 77, 0.5)" data-id="element-214">
        :
      </Text>
      <TimeUnit value={timeLeft.seconds} label="segundos" data-id="element-215" />
    </Flex>;
}